exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.card-content[data-v-db9fc9c4] {\n    padding: 0 0 16px 0;\n}\n", ""]);

